module.exports = __webpack_public_path__ + "media/application/images/svgs/public_square/publicsq_logo_nav-fd796eda9c7d75272c8a9a78983d000b.svg";